import React from 'react';

import Select from 'react-select';

export default (props) => (
  <Select
    {...props}
    classNamePrefix="forms-Select"
  />
);

